import React, { useMemo } from "react"
import { Button, Flex, Text } from "@chakra-ui/react"

import { useBundle } from "@app/hooks/useBundle"

import "@app/theme/css/product.css"
import { useGlobalContext } from "@app/providers/global"

type Props = {
  quantity: number
  product: GatsbyTypes.SanityProduct
  loading?: boolean
}

const ProductAddBundleToCart: React.FC<Props> = ({ product, quantity, loading }) => {
  const { additionalAddToCartProduct, additionalAddToCartLoading, additionalStockOut } = useGlobalContext()
  const { addBundleToCart, bundlePriceDiscounted, bundlePriceFull, isInStock, isOnSale, isLoading } = useBundle(product, quantity)

  const text = useMemo(() => {
    if (!isInStock) {
      return additionalStockOut
    } else {
      return isLoading || loading ? additionalAddToCartLoading : additionalAddToCartProduct
    }
  }, [additionalAddToCartLoading, additionalAddToCartProduct, additionalStockOut, isLoading, isInStock, loading])
  return (
    <Button
      variant="fillRainbowLoader"
      w="100%"
      alignItems="center"
      border="none"
      isDisabled={!isInStock || isLoading || loading}
      onClick={() => addBundleToCart(quantity)}
      transition="none"
      aria-label={text}
      textAlign="center"
      title={text}
    >
      <Text variant="text18">{text}</Text>
      <Flex ml="10px" display="inline-flex">
        {isOnSale ? (
          <>
            <Text variant="text18" pr="5px" textDecoration="line-through">
              {bundlePriceFull}
            </Text>
            <Text variant="text18">{bundlePriceDiscounted}</Text>
          </>
        ) : (
          <Text variant="text18">{bundlePriceFull}</Text>
        )}
      </Flex>
    </Button>
  )
}

export default React.memo(ProductAddBundleToCart)
